import request from '@/utils/request'

export const getRevenueAccruals = params => request.get('/accounting/revenue-accruals', { params })

export const getRevenueAccrualSuggestions = params => request.get('/accounting/revenue-accruals/suggestions', { params })

export const createRevenueAccrual = data => request.post('/accounting/revenue-accruals', data)

export const cancelRevenueAccrual = id => request.post(`/accounting/revenue-accruals/${id}/cancel`)
